export default __webpack_public_path__ + "static/media/bolsos.c3b48d7a.jpg";